const e={currentTimeValueInMilliseconds:(new Date).getTime(),expiryTime:{unit:"days",value:1}};export{e as TOOLBOX_USER_FLOW_IDS_STORAGE_EXPIRY_OPTIONS};
//# sourceMappingURL=useToolBox.constants.js.map
